import styled from "styled-components";
export const ChatListStyle = styled.div`
  background-color: ${({ theme }) => theme.box};
  margin-top: 1rem;
  border-radius: 0.625rem;
  overflow: hidden;
  box-shadow: 0px 1px 10px #00000020;
  height: 730px;
  overflow-y: scroll;
  .users-list {
    .img {
      width: 15%;
      text-align: right;
      img {
        background-color: #e8e8e8;
        width: 40px;
        height: 40px;
        margin: 0 auto;
      }
    }
    li:nth-child(even) {
      background-color: ${({ theme }) => theme.body};
    }
    .user-details {
      width: 60%;
    }
    .message-details {
      text-align: left;
      width: 25%;
    }
    @media (max-width: 1400px) {
      .img {
        width: 20%;
      }
      .user-details {
        width: 45%;
      }
      .message-details {
        width: 35%;
      }
    }
    @media (max-width: 1200px) {
      .img {
        width: 25% !important;
      }
    }
  }
`;
